import { IconButton, Tooltip, useDisclosure } from "@chakra-ui/react";
import { getIn, useFormikContext } from "formik";
import React from "react";
import { FiCode } from "react-icons/fi";
import { EditAsHtmlModal } from "./EditAsHtmlModal";

interface EditAsHtmlButtonProps {
  name: string;
  fieldLabel: string;
}

export const EditAsHtmlButton = ({
  name,
  fieldLabel,
}: EditAsHtmlButtonProps) => {
  const { values, setFieldValue } = useFormikContext();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const currentValue = getIn(values, name);

  return (
    <>
      <Tooltip label="Edit as HTML" placement="top">
        <IconButton
          aria-label={`Edit ${fieldLabel} as HTML`}
          icon={<FiCode />}
          size="xs"
          variant="ghost"
          onClick={onOpen}
        />
      </Tooltip>
      <EditAsHtmlModal
        isOpen={isOpen}
        onClose={onClose}
        title={`Edit ${fieldLabel} as HTML`}
        initialValue={currentValue == null ? "" : String(currentValue)}
        onSave={(html) => setFieldValue(name, html)}
      />
    </>
  );
};
